/**
 * @fileoverview Interior-number and first cross-street fields for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressDetailFields = ({ model, t }) => {
  const {
    getFieldValidationState, getErrorMessage,
    handleInputChange, handleFieldChange,
    handleToggleChange, isAddressReadOnly,
    segundoDomicilioNumeroInterior, setSegundoDomicilioNumeroInterior,
    segundoDomicilioMostrarNumeroInterior, setSegundoDomicilioMostrarNumeroInterior,
    segundoDomicilioEntreCalle1, setSegundoDomicilioEntreCalle1,
    segundoDomicilioMostrarEntreCalle1, setSegundoDomicilioMostrarEntreCalle1,
  } = model;

  return (
    <>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.indoorNumberLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              "domicilio2NumeroInterior",
              segundoDomicilioNumeroInterior,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.location.indoorNumberPlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setSegundoDomicilioNumeroInterior(value);
            handleInputChange("domicilio2NumeroInterior", value);
            handleFieldChange("domicilio2NumeroInterior", value);
          }}
          value={segundoDomicilioNumeroInterior}
          maxLength={10}
          disabled={true}
          style={{ cursor: CURSOR_NOT_ALLOWED }}
        />
        {getErrorMessage("domicilio2NumeroInterior") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("domicilio2NumeroInterior")}
          </p>
        )}
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarNumeroInterior(
                !segundoDomicilioMostrarNumeroInterior,
              );
              handleToggleChange(
                "domicilio2MostrarNumeroInterior",
                !segundoDomicilioMostrarNumeroInterior,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarNumeroInterior
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarNumeroInterior ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.betweenStreet1Label")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              "domicilio2EntreCalle1",
              segundoDomicilioEntreCalle1,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.location.betweenStreet1Placeholder")}
          onChange={(e) => {
            const value = e.target.value;
            setSegundoDomicilioEntreCalle1(value);
            handleInputChange("domicilio2EntreCalle1", value);
            handleFieldChange("domicilio2EntreCalle1", value);
          }}
          value={segundoDomicilioEntreCalle1}
          maxLength={100}
          disabled={true}
          style={{ cursor: CURSOR_NOT_ALLOWED }}
        />
        {getErrorMessage("domicilio2EntreCalle1") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("domicilio2EntreCalle1")}
          </p>
        )}
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarEntreCalle1(
                !segundoDomicilioMostrarEntreCalle1,
              );
              handleToggleChange(
                "domicilio2MostrarEntreCalle1",
                !segundoDomicilioMostrarEntreCalle1,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarEntreCalle1
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarEntreCalle1 ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default SecondAddressDetailFields;
